export const DS_PREFIX = 'wave';
const extractColorComponents = (color) => {
    const colorComponentsRegexp = /hsla?\(\s*(\d{1,3}),\s*(\d{1,3})%,\s*(\d{1,3})%.*\)/i;
    const match = colorComponentsRegexp.exec(color);
    if (match === null)
        return undefined;
    const [, hue, saturation, lightness] = match;
    return `${hue}, ${saturation}%, ${lightness}%`;
};
export const generateCssVariableEntries = (tokenObject, path = []) => Object.entries(tokenObject).flatMap(([key, value]) => {
    if (typeof value === 'object') {
        return generateCssVariableEntries(value, [...path, key]);
    }
    return { variable: [...path, key].join('-').toLowerCase(), value };
});
const generateHslComponentsCssVariableEntries = (entries) => entries
    .map(({ variable, value }) => {
    if (typeof value !== 'string')
        return undefined;
    const colorComponents = extractColorComponents(value);
    return colorComponents === undefined ? undefined : { variable: `${variable}-hsl`, value: colorComponents };
})
    .filter(entry => entry !== undefined);
export const applyPrefix = (variableName, tier, namespace = 'color') => `--${DS_PREFIX}-${tier}-${namespace}-${variableName}`;
export const generateCssVariables = (tokens, tier) => {
    const entries = generateCssVariableEntries(tokens);
    const hslComponentsEntries = generateHslComponentsCssVariableEntries(entries);
    return [...entries, ...hslComponentsEntries].map(({ variable, value }) => `${applyPrefix(variable, tier)}: ${value};`);
};
export const generateBareTierCssVariables = (tokens) => generateCssVariables(tokens, 'b');
export const generateSemanticTierCssVariables = (tokens) => generateCssVariables(tokens, 's');
export const getSemanticValue = (token) => `var(--${DS_PREFIX}-s-color-${token})`;
